import { useEffect } from "react";

import Header from "@/components/Header";
import ApplicationForm from "@/components/ApplicationForm";
import useLenisScroll from "@/hooks/useLenisScroll";

export default function Apply() {
    useLenisScroll();
    useEffect(() => {
        document.title = "Apply - Vibecity";
    }, []);
    return (
        <main data-testid="apply-page" className="relative bg-background">
            <Header />
            <div style={{ paddingTop: 80 }}>
                <ApplicationForm />
            </div>
        </main>
    );
}
